// API Configuration
// This file centralizes API URL configuration for different environments

// Use environment variable or fallback to localhost for development
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

// Ensure no trailing slash
export const API_URL = API_BASE_URL.replace(/\/$/, '');

// Log current API URL (only in development)
if (process.env.NODE_ENV === 'development') {
  console.log('🔗 API URL:', API_URL);
  console.log('🌍 Environment:', process.env.REACT_APP_ENV || 'development');
}

// API endpoints
export const API_ENDPOINTS = {
  // Auth
  AUTH: {
    LOGIN: `${API_URL}/api/auth/login`,
    REGISTER: `${API_URL}/api/users/register`,
    LOGOUT: `${API_URL}/api/auth/logout`,
  },
  
  // Users
  USERS: {
    ME: `${API_URL}/api/users/me`,
    UPDATE: `${API_URL}/api/users/me`,
  },
  
  // Articles
  ARTICLES: {
    BASE: `${API_URL}/api/articles`,
    BY_ID: (id) => `${API_URL}/api/articles/${id}`,
    SEARCH: `${API_URL}/api/articles/search`,
  },
  
  // Courses
  COURSES: {
    BASE: `${API_URL}/api/courses`,
    BY_ID: (id) => `${API_URL}/api/courses/${id}`,
    SECTIONS: (id) => `${API_URL}/api/course-sections/course/${id}`,
    SECTION_QUESTIONS: (sectionId) => `${API_URL}/api/course-questions/section/${sectionId}`,
    SECTION_CONTENTS: (sectionId) => `${API_URL}/api/course-contents/section/${sectionId}`,
  },
  
  // Live Sessions
  LIVE_SESSIONS: {
    BY_COURSE: (courseId) => `${API_URL}/api/live-sessions/course/${courseId}`,
    BY_SECTION: (sectionId) => `${API_URL}/api/live-sessions/section/${sectionId}`,
    UPCOMING: (courseId) => `${API_URL}/api/live-sessions/course/${courseId}/upcoming`,
    BY_ID: (id) => `${API_URL}/api/live-sessions/${id}`,
    CREATE: `${API_URL}/api/live-sessions`,
    UPDATE: (id) => `${API_URL}/api/live-sessions/${id}`,
    DELETE: (id) => `${API_URL}/api/live-sessions/${id}`,
  },
  
  // Question Packages
  PACKAGES: {
    BASE: `${API_URL}/api/question-packages`,
    BY_ID: (id) => `${API_URL}/api/question-packages/${id}`,
    PURCHASE: (id) => `${API_URL}/api/question-packages/${id}/purchase`,
  },
  
  // Questions
  QUESTIONS: {
    BASE: `${API_URL}/api/questions`,
    BY_ID: (id) => `${API_URL}/api/questions/${id}`,
    BY_SECTION: (sectionId) => `${API_URL}/api/questions/section/${sectionId}`,
  },
  
  // IDE
  IDE: {
    EXECUTE: `${API_URL}/api/ide/execute`,
    TEMPLATES: `${API_URL}/api/ide/templates`,
    CONVERT: `${API_URL}/api/ide/convert-code`,
  },
  
  // File Upload
  UPLOAD: {
    VIDEO: `${API_URL}/api/upload/video`,
    GET_VIDEO: (filename) => `${API_URL}/api/upload/videos/${filename}`,
  },
  
  // Dashboard
  DASHBOARD: {
    BASE: `${API_URL}/api/user-dashboard`,
    STATS: `${API_URL}/api/user-dashboard/stats`,
  },
  
  // Internship
  INTERNSHIP: {
    REGISTRATION_STATUS: `${API_URL}/api/internship/registration-status`,
    CREATE_ORDER: `${API_URL}/api/internship/payment/create-order`,
    VERIFY_PAYMENT: `${API_URL}/api/internship/payment/verify`,
    ADMIN_REGISTRATIONS: `${API_URL}/api/internship/admin/registrations`,
  },

  // Health
  HEALTH: `${API_URL}/actuator/health`,
};

// Helper function to get full API URL
export const getApiUrl = (path) => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  return `${API_URL}/${cleanPath}`;
};

// Export for backward compatibility
export default API_URL;


